export const nutritionSampleData=
     [
            {
            name: "Crude protein",
            unit: "%DM",
            min: 17,
            max: 18,
            consider: true
            },
            {
            name: "Soluble protein",
            unit: "%CP",
            min: 30,
            max: 34,
            consider: true
            },
            {
            name: "Degradable protein",
            unit: "%CP",
            min: 62,
            max: 66,
            consider: true
            },
            {
            name: "Undegradable protein",
            unit: "%CPd",
            min: 34,
            max: 38,
            consider: true
            },
            {
            name: "NEL",
            unit: "Mcal/lb DMe",
            min: 0.76,
            max: 0.8,
            consider: true
            },
            {
            name: "Forage NDF",
            unit: "%DM",
            min: 21,
            max: 24,
            consider: true
            },
            {
            name: "Total NDF",
            unit: "%DM",
            min: 28,
            max: 32,
            consider: true
            },
            {
            name: "NFC",
            unit: "%DM",
            min: 32,
            max: 38,
            consider: true
            },
            {
            name: "Fat",
            unit: "%DMf",
            min: 5,
            max: 7,
            consider: true
            },
            {
            name: "Calcium",
            unit: "%DMg",
            min: 0.81,
            max: 0.91,
            consider: true
            },
            {
            name: "Phosphorous",
            unit: "%DMg",
            min: 0.4,
            max: 0.42,
            consider: true
            },
            {
            name: "Magnesium",
            unit: "%DMg",
            min: 0.28,
            max: 0.37,
            consider: true
            },
            {
            name: "Potassium",
            unit: "%DMh",
            min: 1,
            max: 1.5,
            consider: true
            },
            {
            name: "Sulfur",
            unit: "%DM",
            min: 0.23,
            max: 0.24,
            consider: true
            },
            {
            name: "Salt",
            unit: "%DM",
            min: 0.45,
            max: 0.5,
            consider: true
            },
            {
            name: "Sodium",
            unit: "%DM",
            min: 0.2,
            max: 0.25,
            consider: true
            },
            {
            name: "Chlorine",
            unit: "%DM",
            min: 0.25,
            max: 0.3,
            consider: true
            },
            {
            name: "Manganese",
            unit: "ppm",
            min: 44,
            max: 45,
            consider: true
            },
            {
            name: "Copper",
            unit: "ppmi",
            min: 11,
            max: 25,
            consider: true
            },
            {
            name: "Zinc",
            unit: "ppm",
            min: 70,
            max: 80,
            consider: true
            },
            {
            name: "Iron",
            unit: "ppm",
            min: 100,
            max: 110,
            consider: true
            },
            {
            name: "Added selenium",
            unit: "ppm",
            min: 0.3,
            max: 0.4,
            consider: true
            },
            {
            name: "Added cobalt",
            unit: "ppm",
            min: 0.2,
            max: 0.3,
            consider: true
            },
            {
            name: "Added iodine",
            unit: "ppm",
            min: 0.5,
            max: 0.6,
            consider: true
            },
            {
            name: "Total vitamin A",
            unit: "IU/lb DM",
            min: 4500,
            max: 5000,
            consider: true
            },
            {
            name: "Added vitamin D",
            unit: "IU/lb DM",
            min: null,
            max: null,
            consider: false
            },
            {
            name: "Dry Matter",
            unit: "",
            min: 750,
            max: 1100,
            consider: true
            },
            {
            name: "Total vitamin E",
            unit: "IU/lb DM",
            min: 30,
            max: 50,
            consider: true
            },
            {
            name: "Approximate concentrate",
            unit: "%DMj",
            min: 55,
            max: 60,
            consider: true
            },
            {
            name: "Approximate DMI",
            unit: "%BW",
            min: 4,
            max: 8,
            consider: true
            }
    ];

    export const nutritionEmptyData=
     [
            {
            name: "Crude protein",
            unit: "%DM",
            min: 0,
            max: 0,
            consider: true,
            },
            {
            name: "Soluble protein",
            unit: "%CP",
            min: 0,
            max: 0,
            consider: true,
            },
            {
            name: "Degradable protein",
            unit: "%CP",
            min: 0,
            max: 0,
            consider: true,
            },
            {
            name: "Undegradable protein",
            unit: "%CPd",
            min: 0,
            max: 0,
            consider: true,
            },
            {
            name: "NEL",
            unit: "Mcal/lb DMe",
            min: 0,
            max: 0,
            consider: true,
            },
            {
            name: "Forage NDF",
            unit: "%DM",
            min: 0,
            max: 0,
            consider: true,
            },
            {
            name: "Total NDF",
            unit: "%DM",
            min: 0,
            max: 0,
            consider: true,
            },
            {
            name: "NFC",
            unit: "%DM",
            min: 0,
            max: 0,
            consider: true,
            },
            {
            name: "Fat",
            unit: "%DMf",
            min: 0,
            max: 0,
            consider: true,
            },
            {
            name: "Calcium",
            unit: "%DMg",
            min: 0,
            max: 0,
            consider: true,
            },
            {
            name: "Phosphorous",
            unit: "%DMg",
            min: 0,
            max: 0,
            consider: true,
            },
            {
            name: "Magnesium",
            unit: "%DMg",
            min: 0,
            max: 0,
            consider: true,
            },
            {
            name: "Potassium",
            unit: "%DMh",
            min: 0,
            max: 0,
            consider: true,
            },
            {
            name: "Sulfur",
            unit: "%DM",
            min: 0,
            max: 0,
            consider: true,
            },
            {
            name: "Salt",
            unit: "%DM",
            min: 0,
            max: 0,
            consider: true,
            },
            {
            name: "Sodium",
            unit: "%DM",
            min: 0,
            max: 0,
            consider: true,
            },
            {
            name: "Chlorine",
            unit: "%DM",
            min: 0,
            max: 0,
            consider: true,
            },
            {
            name: "Manganese",
            unit: "ppm",
            min: 0,
            max: 0,
            consider: true,
            },
            {
            name: "Copper",
            unit: "ppmi",
            min: 0,
            max: 0,
            consider: true,
            },
            {
            name: "Zinc",
            unit: "ppm",
            min: 0,
            max: 0,
            consider: true,
            },
            {
            name: "Iron",
            unit: "ppm",
            min: 0,
            max: 0,
            consider: true,
            },
            {
            name: "Added selenium",
            unit: "ppm",
            min: 0,
            max: 0,
            consider: true,
            },
            {
            name: "Added cobalt",
            unit: "ppm",
            min: 0,
            max: 0,
            consider: true,
            },
            {
            name: "Added iodine",
            unit: "ppm",
            min: 0,
            max: 0,
            consider: true,
            },
            {
            name: "Total vitamin A",
            unit: "IU/lb DM",
            min: 0,
            max: 0,
            consider: true,
            },
            {
            name: "Added vitamin D",
            unit: "IU/lb DM",
            min: 0,
            max: 0,
            consider: true,
            },
            {
            name: "Dry Matter",
            unit: "",
            min: 0,
            max: 0,
            consider: true,
            },
            {
            name: "Total vitamin E",
            unit: "IU/lb DM",
            min: 0,
            max: 0,
            consider: true,
            },
            {
            name: "Approximate concentrate",
            unit: "%DMj",
            min: 0,
            max: 0,
            consider: true,
            },
            {
            name: "Approximate DMI",
            unit: "%BW",
            min: 0,
            max: 0,
            consider: true,
            }
    ]
